module.exports = __webpack_public_path__ + "img/central-african-republic.d95f6e2a.svg";